export default {
    values: {
        'Errors were found that can affect the rendering of the chart':
            'Errors were found that can affect the rendering of the chart',
        'View the chart anyway': 'View the chart anyway',
        Grid: 'Grid',
        'GLOBAL CHART OPTIONS': 'GLOBAL CHART OPTIONS',
        'Y AXIS OPTIONS': 'Y AXIS OPTIONS',
        Groups: 'Groups',
        'New Group': 'New Group',
        'Add Group': 'Add Group',
        Remove: 'Remove',
        'Add groups and select channels to create a custom visualization':
            'Add groups and select channels to create a custom visualization',
        'Values grouped by grid.': 'Values grouped by grid.',
        'Number of columns': 'Number of columns',
        'Title font size': 'Title font size',
        'Value font size': 'Value font size',
        'Uom font size': 'Uom font size',
        'Title bold': 'Title bold',
        'Value bold': 'Value bold',
        'Uom bold': 'Uom bold',
        'Icon name': 'Icon name',
        'Icon color': 'Icon color',
        'Background color': 'Background color',
        ICON_NAME_DESCRIPTION: 'Name of the Font Awesome icon',
        'Group title': 'Group title',
        'Custom alarm styles': 'Custom alarm styles',
        Critical: 'Critical',
        Warning: 'Warning',
        Configured: 'Configured',
        'Not mapped': 'Not mapped',
        'Group color': 'Group color'
    }
}
